import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { listStatus } from "../../reducers/violations";
import Style from "./violations.module.css";

/** Grid localization for the ticket lists: blank while pending, a red error after a failed load. */
export default function useTicketListLocalization(status) {
  const { t } = useTranslation();

  return useMemo(() => {
    switch (status) {
      case listStatus.PENDING:
        return { body: { emptyDataSourceMessage: "" } };
      case listStatus.FAILED:
        return {
          body: {
            emptyDataSourceMessage: <span className={Style.listError}>{t("Violations.errorLoading")}</span>,
          },
        };
      default:
        return undefined;
    }
  }, [status, t]);
}
